var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControlRecurring24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Control/Recurring24",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconRecurring",
    transform: "translate(0.000000, 3.000000)",
    fill: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.24597168,8.88956222 L2.01421356,10.1213203 L0.6,8.70710678 L4.30710678,5 L8.01421356,8.70710678 L6.6,10.1213203 L5.24255497,8.76387532 C5.56132418,12.3563799 8.53100259,15.1213203 12.214214,15.1213203 C14.114214,15.1213203 15.914214,14.3213203 17.114214,13.0213203 L18.614214,14.5213203 C16.914214,16.1213203 14.714214,17.1213203 12.214214,17.1213203 C7.47311464,17.1213203 3.63113621,13.5248366 3.24597168,8.88956222 Z M20.9682423,8.23175772 L22.2,7 L23.6142136,8.41421356 L19.9071068,12.1213203 L16.2,8.41421356 L17.6142136,7 L18.9716591,8.35744551 C18.6528901,4.76494065 15.6832116,2 12,2 C10.1,2 8.3,2.8 7.1,4.1 L5.6,2.6 C7.3,1 9.5,0 12,0 C16.7410992,0 20.5830776,3.59648349 20.9682423,8.23175772 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlRecurring24);
export default __webpack_public_path__ + "static/media/controlRecurring24.b08741c6897e439ecfe057ce23e8e0cf.svg";
export { ForwardRef as ReactComponent };